/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./origin.defs.js";
export { main as default } from "./origin.defs.js";
